import { render, staticRenderFns } from "./HouseReviewScore.vue?vue&type=template&id=226dc15e&scoped=true"
import script from "./HouseReviewScore.vue?vue&type=script&lang=js"
export * from "./HouseReviewScore.vue?vue&type=script&lang=js"
import style0 from "./HouseReviewScore.vue?vue&type=style&index=0&id=226dc15e&prod&scoped=true&lang=css"
import style1 from "./HouseReviewScore.vue?vue&type=style&index=1&id=226dc15e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226dc15e",
  null
  
)

export default component.exports